import api from './../../api/userinfo.js'

const user = {
  state: {
    userData: '',
    isLogin: null,
    tabView: 'select2',
    menuCofig: {
      bagVehicle: 1,
      bagPlan: 1,
      chargingBerth: 1,
      coupon: 1,
      diffTime: 0,
      elecInvoice: 1,
      etcp: 1,
      filterParkingType: 1,
      roadParking: 1,
      scan: 1
    },
    paramConfig: {},
    isMenuSet: false
  },
  actions: {
    commitIsLogin({ commit, state }) {
      const promise = new Promise((resolve) => {
        if (state.isLogin === null) {
          api.getUserLoginState().then(res => {
            if (res) {
              commit('setIsLogin', res.loginState)
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
      return promise
    },
    commitMenuCofig({ commit, state }) {
      const promise = new Promise((resolve) => {
        if (!state.isMenuSet) {
          api.getMenuConfig().then(res => {
            if (res) {
              commit('setIsMenuSet', true)
              commit('setMenuCofig', res.data)
              resolve(res.data)
            }
          })
        } else {
          resolve(state.menuCofig)
        }
      })
      return promise
    },
    commitParamCofig({ commit }) {
      api.getParamConfigs().then(res => {
        if (res.data) {
          commit('setParamConfig', res.data)
        }
      })
    }
  },
  mutations: {
    myMounthTab(state) {
      state.tabView = 'select1'
      state.iscur = 0
    },
    newMounthTab(state) {
      state.tabView = 'select2'
      state.iscur = 1
    },
    getUserData(state, response) {
      state.userData = response
      // console.log(123, response);
    },
    setIsLogin(state, data) {
      state.isLogin = data
    },
    setIsMenuSet(state, data) {
      state.isMenuSet = data
    },
    setMenuCofig(state, config) {
      state.menuCofig = Object.assign({}, config)
    },
    setParamConfig(state, config) {
      state.paramConfig = Object.assign({}, config)
    }
  },
  getters: {
    setUserData: state => state.userData,
    menuCofig: state => state.menuCofig,
    paramConfig: state => state.paramConfig
  }
}

export default user
